export const pickFallbackRedirectId = <TId, TItem extends { id: TId }>(
  list: ReadonlyArray<TItem> | undefined,
  excludeId: TId,
): TId | null => list?.find((item) => item.id !== excludeId)?.id ?? null;
